import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { Seo } from "../components/Seo";
import { api } from "../lib/api";

const EASE = [0.22, 1, 0.36, 1];
const lineInitial = { opacity: 0, y: 24 };
const lineInView = { opacity: 1, y: 0 };
const lineViewport = { once: true, margin: "-40px" };

export default function Manifesto() {
  const { data } = useQuery({
    queryKey: ["manifesto"],
    queryFn: async () => (await api.get("/manifesto")).data,
  });
  const lines = data?.lines || [];

  return (
    <>
      <Seo title="Manifesto" description="Beauty can transform more than appearance. Read the Glam Wagon manifesto — proof that integrity scales." />
      <section className="min-h-screen flex flex-col justify-center py-40 px-6 lg:px-12" data-testid="manifesto-section">
        <div className="max-w-5xl mx-auto text-center">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="eyebrow mb-12"
          >
            {data?.eyebrow || "Our Manifesto"}
          </motion.p>
          <div className="space-y-4">
            {lines.map((line, i) => (
              <motion.p
                key={line}
                initial={lineInitial}
                whileInView={lineInView}
                viewport={lineViewport}
                transition={{ duration: 0.8, delay: i * 0.05, ease: EASE }}
                className={`font-serif leading-[1.1] tracking-tight text-ink ${
                  i === 0 || i === lines.length - 2
                    ? "text-4xl sm:text-6xl lg:text-7xl italic"
                    : "text-3xl sm:text-5xl lg:text-6xl"
                }`}
              >
                {line}
              </motion.p>
            ))}
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            className="mt-16 text-gold font-serif text-2xl italic"
          >
            {data?.closing || "This is only the beginning."}
          </motion.p>
        </div>
      </section>
    </>
  );
}
